import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import TagService from "../services/manager/tagService";
import {
  Alert,
  Box,
  Button,
  Container,
  CssBaseline,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  Pagination,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  SnackbarContent,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ImageSortableList from "./components/imageSortableList";
import AdminNavigation from "./adminNavigation";
import LiqueModal from "../customer/components/liqueModal";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TrashIcon from "../assets/icon/TrashIcon";
import { btnStyleContrast, btnStyleOutlined, subHeaderStyleContrast, textExtraSmallStyleContrast, textSmallStyleContrast, headerStyleContrast } from "../helper/style";
import { capitalizeWords } from "../helper/helperFunctions";
import { NumericFormat } from "react-number-format";

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default function ReviewTag() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setmsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [listTag, setListTag] = useState([]);
  const [openTambah, setOpenTambah] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [errors, setErrors] = useState({});
  const [showMsgImage, setShowMsgImage] = useState(false);
  const [msgImageError, setMsgImageError] = useState("");

  const [msgError, setMsgError] = useState();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [flag, setFlag] = useState("");
  const [shown, setShown] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [images, setImages] = useState([]);
  const [oldImages, setOldImages] = useState([]);
  const [showOrder, setShowOrder] = useState(0);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [selectedFlag, setSelectedFlag] = useState("Semua");
  const flags = ["Semua", "Brand", "Main", "Secondary"];

  const onDrop = useCallback(
    (acceptedFiles) => {
      // Handle the files
      const validFiles = acceptedFiles.filter((file) =>
        /\.(jpg|jpeg|png|gif)$/i.test(file.name)
      );
      console.log(acceptedFiles);
      if (validFiles.length > 0) {
        setShowMsgImage(false);
        const filePreviews = validFiles.map((file) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          return new Promise((resolve) => {
            reader.onload = () => {
              resolve({
                path: file.name,
                preview: reader.result,
                originalFile: file,
              });
            };
          });
        });

        Promise.all(filePreviews)
          .then((images) => {
            setImages(images);
          })
          .catch((error) => {
            console.error("Error reading files:", error);
          });
      } else {
        setShowMsgImage(true);
        setMsgImageError(
          "Invalid file types detected. Please upload only image files."
        );
        console.error(
          "Invalid file types detected. Please upload only image files."
        );
      }
    },
    [setImages]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const activateSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = () => {
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const validate = () => {
    let tempErrors = {};

    if (!title) {
      tempErrors.title = "Nama tag harus diisi";
    }

    if (!flag) {
      tempErrors.flag = "Flag harus dipilih";
    }

    if (showOrder == null || showOrder === '') {
      tempErrors.showOrder = "Urutan harus diisi";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleOpenEdit = (row) => {
    setTitle(row.title);
    setUpdateId(row.id);
    setDescription(row.description);
    setFlag(row.flag);
    setShown(row.shown === 1 ? true : false);
    setOpenEdit(true);
    setImages([]);
    setOldImages(row.images || []);
    setShowOrder(row.showOrder);
  };

  const resetDialog = () => {
    setErrors({});
    setTitle("");
    setDescription("");
    setFlag("");
    setShown(false);
    setImages([]);
    setOldImages([]);
    setShowOrder(0);
  }

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setUpdateId("");
    resetDialog();
  };

  const handleOpenTambah = () => setOpenTambah(true);
  const handleCloseTambah = () => {
    setOpenTambah(false);
    resetDialog();
  };

  const handleOpenDelete = (row) => {
    setUpdateId(row.id);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setUpdateId("");
  };

  const handleDeleteImage = (name) => {
    setOldImages(oldImages.filter(image => image !== name));
  }

  const getAllTag = async () => {
    try {
      let flag = selectedFlag.toLowerCase();
      if (flag === 'semua') {
        flag = '';
      }

      const response = await TagService.getTagListPageable(
        page, 
        perPage, 
        flag, 
        search
      );

      if (response) {
        const data = response.data;
        setListTag(data.tagModelList);
        setTotalItem(data.totalData);
        setTotalPage(data.totalPage);
      }
    } catch (error) {
      console.error(error);
      setMsgError("Error while fetching list tags");
      activateError();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        const response = await TagService.insertTag(
          title,
          description,
          flag,
          shown,
          images,
          showOrder
        );
        if (response) {
          setmsgSuccess("Add tag success");
          activateSuccess();
          getAllTag();
        }
      } catch (error) {
        console.error(error);
        setMsgError("Error while inserting tags");
        activateError();
      } finally {
        handleCloseTambah();
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        const response = await TagService.updateTag(
          updateId,
          title,
          description,
          shown,
          images,
          oldImages,
          showOrder
        );
        if (response) {
          setmsgSuccess("Update tag success");
          activateSuccess();
          getAllTag();
        }
      } catch (error) {
        console.error(error);
        setMsgError("Error while updating tags");
        activateError();
      } finally {
        handleCloseEdit();
      }
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const tag = listTag.find(data => data.id === updateId);
      // if (tag && tag.shown === 1) {
      //   setMsgError("Tidak bisa hapus tag yang ditampilkan di halaman utama");
      //   activateError();

      //   return;
      // }

      const response = await TagService.deleteTag(updateId);
      if (response) {
        setmsgSuccess("Delete tag success");
        activateSuccess();
        getAllTag();
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 422) {
        setMsgError("Gagal Hapus Tag, Tag masih dipakai oleh beberapa stok");
      } else {
        setMsgError("Error while deleting tags");
      }
      activateError();
    } finally {
      handleCloseDelete();
    }
  };

  useEffect(() => {
    getAllTag();
  }, []);

  const searchTimeout = useRef(null);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setPage(1);
      getAllTag();
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [search]);

  useEffect(() => {
    getAllTag();
    window.scrollTo(0, 0);
  }, [page]);

  useEffect(() => {
    setPage(1);
    getAllTag();
  }, [selectedFlag]);

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />
      <Container
        component="main"
        maxWidth="xl"
      >
        <RootContainer>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showSuccess}
            autoHideDuration={3000}
            onClose={() => setShowSuccess(false)}
          >
            <SnackbarContent
              sx={{ backgroundColor: "#19B600" }} 
              message={msgSuccess}/>
          </Snackbar>
    
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showError}
            autoHideDuration={3000}
            onClose={() => setShowError(false)}
          >
            <SnackbarContent 
              sx={{ backgroundColor: "#E50B0B" }} 
              message={msgError}/>
          </Snackbar>

          <Grid container spacing={1} alignItems="center" marginBottom={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...headerStyleContrast }}>
                Kelola Brand
              </Typography>
            </Grid>
            <Grid item xs={6} sm={8} md={4}>
              <TextField
                fullWidth
                value={search}
                placeholder="Cari Tag..."
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{ 
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlinedIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Button 
                endIcon={<AddIcon sx={{ color: "white" }} />}
                style={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }} 
                onClick={handleOpenTambah}>
                Tambah Tag
              </Button>
            </Grid>

            <Grid item xs={12} display="flex" justifyContent="end" marginTop={2}>
              <TextField
                id="flag-select"
                variant="standard"
                select
                value={selectedFlag}
                onChange={(e) => setSelectedFlag(e.target.value)}
                sx={{ width: "150px", maxWidth: "100%" }}
                InputProps={{ 
                  disableUnderline: true
                 }}
              >
                {flags.map((flag) => (
                  <MenuItem key={flag} value={flag}>
                    {flag}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          <Box sx={{ marginTop: "20px", width: "100%" }} marginBottom={3}>
            {
              listTag.map(tag => (
                <Box  
                  key={tag.id}
                  sx={{ background: "white", borderRadius: "16px", padding: "16px", marginBottom: "20px", boxShadow: "2px 2px 10px rgba(0, 0, 0, .2)" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography sx={{ ...subHeaderStyleContrast, fontWeight: "500" }}>
                        {tag.title}
                      </Typography>
                      <Typography sx={{ ...textSmallStyleContrast }} marginTop={1}>
                        {tag.description || '-'}
                      </Typography>
                      <Typography sx={{ ...textExtraSmallStyleContrast }}>
                        { capitalizeWords(tag.flag) }
                        {
                          tag.shown === 1 && ` • Ditampilkan di Home`
                        }
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} display="flex" justifyContent="end" alignItems="end" gap="10px">
                      <Button 
                        sx={{ ...btnStyleContrast, borderRadius: "50px", width: "120px" }}
                        endIcon={<EditOutlinedIcon />}
                        onClick={() => handleOpenEdit(tag)}
                      >
                        Edit
                      </Button>
                      <Button 
                        sx={{ ...btnStyleOutlined, borderRadius: "50px", width: "120px", color: "red", border: "1px solid red" }}
                        endIcon={<TrashIcon color="red" />}
                        onClick={() => handleOpenDelete(tag)}
                      >
                        Delete
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ))
            }

            <Box display="flex" justifyContent="center">
              <Pagination sx={{ 
                  '& .MuiPaginationItem-root': {
                    color: 'black', 
                  },
                  '& .MuiPaginationItem-icon': {
                    color: 'black', 
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'black !important', 
                    color: 'white', 
                  },
                }} 
                size="small"
                count={totalPage} 
                page={page}
                onChange={(_event, page) => setPage(page)} />
            </Box>  
          </Box>
        </RootContainer>

        <LiqueModal open={openTambah} onClose={handleCloseTambah}>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>Nama Tag *</Typography>
                <TextField
                  fullWidth
                  autoComplete="off"
                  value={title}
                  error={!!errors.title}
                  helperText={errors.title}
                  FormHelperTextProps={{ sx: { color: "red" } }}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>Deskripsi</Typography>
                <TextareaAutosize
                  style={{ width: "100%" }}
                  minRows={3}
                  autoComplete="off"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {!!errors.description ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {errors.description}
                  </FormHelperText>
                ) : null}
              </Grid>
              <Grid item xs={6}>
                <Typography>Ditampilkan di Halaman Utama ?</Typography>
                <Select
                  fullWidth
                  autoComplete="off"
                  value={shown}
                  onChange={(e) => setShown(e.target.value)}
                >
                  <MenuItem value={true}>Ya</MenuItem>
                  <MenuItem value={false}>Tidak</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={6}>
                <Typography>Urutan</Typography>
                <NumericFormat
                  customInput={TextField}
                  fullWidth
                  autoComplete="off"
                  value={showOrder}
                  error={!!errors.showOrder}
                  helperText={errors.showOrder}
                  FormHelperTextProps={{ sx: { color: "red" } }}
                  onChange={(e) => setShowOrder(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>Tipe Tag *</Typography>
                <RadioGroup
                  row
                  name="flag"
                  value={flag}
                  onChange={(e) => setFlag(e.target.value)}
                >
                  <FormControlLabel
                    value="main"
                    control={<Radio />}
                    label="Main"
                  />
                  <FormControlLabel
                    value="secondary"
                    control={<Radio />}
                    label="Secondary"
                  />
                  <FormControlLabel
                    value="brand"
                    control={<Radio />}
                    label="Brand"
                  />
                </RadioGroup>
                {!!errors.flag ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {errors.flag}
                  </FormHelperText>
                ) : null}
              </Grid>

              <Grid item xs={12}>
                <Box
                  {...getRootProps()}
                  sx={{
                    border: "2px dashed #aaa",
                    borderRadius: "4px",
                    padding: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
                    transition: "background-color 0.2s",
                  }}
                >
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <Typography>Drop the files here...</Typography>
                  ) : (
                    <Typography>
                      Drag 'n' drop some files here, or click to select
                      files
                    </Typography>
                  )}
                </Box>
                {!showMsgImage && (
                  <Box
                    mt={2}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    {images.map((file, index) => (
                      <Box key={index} mb={2} mr={2}>
                        <Typography>{file.path}</Typography>
                        <img
                          src={file.preview}
                          alt={file.path}
                          style={{ maxWidth: "70%", maxHeight: "100px" }}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
                {showMsgImage && (
                  <Typography sx={{ color: "red" }}>
                    {msgImageError}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  fullWidth
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </LiqueModal>

        <LiqueModal open={openEdit} onClose={handleCloseEdit}>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>Nama Tag *</Typography>
                <TextField
                  fullWidth
                  autoComplete="off"
                  value={title}
                  error={!!errors.title}
                  helperText={errors.title}
                  FormHelperTextProps={{ sx: { color: "red" } }}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>Deskripsi</Typography>
                <TextareaAutosize
                  style={{ width: "100%" }}
                  minRows={3}
                  autoComplete="off"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {!!errors.description ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {errors.description}
                  </FormHelperText>
                ) : null}
              </Grid>
              <Grid item xs={6}>
                <Typography>Ditampilkan di Halaman Utama ?</Typography>
                <Select
                  fullWidth
                  autoComplete="off"
                  value={shown}
                  onChange={(e) => setShown(e.target.value)}
                >
                  <MenuItem value={true}>Ya</MenuItem>
                  <MenuItem value={false}>Tidak</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={6}>
                <Typography>Urutan</Typography>
                <NumericFormat
                  customInput={TextField}
                  fullWidth
                  autoComplete="off"
                  value={showOrder}
                  error={!!errors.showOrder}
                  helperText={errors.showOrder}
                  FormHelperTextProps={{ sx: { color: "red" } }}
                  onChange={(e) => setShowOrder(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>Tipe Tag *</Typography>
                <RadioGroup
                  row
                  name="flag"
                  value={flag}
                  onChange={(e) => setFlag(e.target.value)}
                >
                  <FormControlLabel
                    value="main"
                    control={<Radio />}
                    label="Main"
                    disabled
                  />
                  <FormControlLabel
                    value="secondary"
                    control={<Radio />}
                    label="Secondary"
                    disabled
                  />
                  <FormControlLabel
                    value="brand"
                    control={<Radio />}
                    label="Brand"
                    disabled
                  />
                </RadioGroup>
                {!!errors.flag ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {errors.flag}
                  </FormHelperText>
                ) : null}
              </Grid>
              <Grid item xs={12}>
                <Box
                  {...getRootProps()}
                  sx={{
                    border: "2px dashed #aaa",
                    borderRadius: "4px",
                    padding: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
                    transition: "background-color 0.2s",
                  }}
                >
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <Typography>Drop the files here...</Typography>
                  ) : (
                    <Typography>
                      Drag 'n' drop some files here, or click to select
                      files
                    </Typography>
                  )}
                </Box>
                {!showMsgImage && (
                  <Box
                    mt={2}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    {images.map((file, index) => (
                      <Box key={index} mb={2} mr={2}>
                        <Typography>{file.path}</Typography>
                        <img
                          src={file.preview}
                          alt={file.path}
                          style={{ maxWidth: "70%", maxHeight: "100px" }}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
                {showMsgImage && (
                  <Typography sx={{ color: "red" }}>
                    {msgImageError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography>Gambar Sekarang</Typography>
                  <DndProvider backend={HTML5Backend}>
                    <ImageSortableList 
                      images={oldImages}
                      setImages={setOldImages}
                      alt={title}
                      deleteItem={handleDeleteImage}
                    />
                  </DndProvider>
                <Grid container spacing={2} marginTop={0}>
                  {
                    oldImages.length <= 0 ? (
                      <Grid item xs={12} textAlign="center">Belum ada Gambar</Grid>
                    ) : null
                  }
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  fullWidth
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </LiqueModal>

        <LiqueModal open={openDelete} onClose={handleCloseDelete} width="600px">
          <Box textAlign="center">
            <Typography id="spring-modal-title" variant="h6" component="h2">
              Apakah kamu yakin ingin membuang data ini?
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Button variant="outlined" onClick={handleCloseDelete}>
                Batal
              </Button>
              <Button
                variant="outlined"
                onClick={handleConfirmDelete}
                sx={{ ml: 2, backgroundColor: "red", color: "white" }}
              >
                Buang
              </Button>
            </Box>
          </Box>
        </LiqueModal>
      </Container>
    </Box>
  );
}
